import React from 'react';
type Variante = 'primario' | 'secundario' | 'contorno' | 'suave' | 'peligro' | 'texto';
type Tamano = 'md' | 'sm';
interface BotonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: Variante;
  tamano?: Tamano;
  children: React.ReactNode;
}
const ESTILOS: Record<Variante, string> = {
  primario: 'bg-verde text-white hover:bg-verde-hover border border-transparent',
  secundario: 'bg-vino text-white hover:bg-vino-claro border border-transparent',
  contorno: 'bg-white text-vino border border-vino/20 hover:border-vino hover:bg-vino/5',
  suave: 'bg-vino/5 text-vino border border-transparent hover:bg-vino/10',
  peligro: 'bg-white text-alerta border border-alerta/40 hover:bg-alerta/5',
  texto: 'bg-transparent text-tinta-sec hover:text-vino border border-transparent'
};
export function Boton({
  variante = 'primario',
  tamano = 'md',
  className = '',
  children,
  ...props
}: BotonProps) {
  const medida = tamano === 'sm' ? 'min-h-[44px] px-3 text-sm' : 'min-h-[44px] px-4 text-sm';
  return <button {...props} className={`inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${medida} ${ESTILOS[variante]} ${className}`} data-id="element-396" data-mp="38sj0mbiun6h">
      {children}
    </button>;
}